import Vue from 'vue'
import Vuex from 'vuex'
import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls";

let ls = new SecureLS({ isCompression: false });

Vue.use(Vuex)

const defaultState = {
    employees: [],
    userRole: {},
    selectedFacility: undefined,
    showRespSafe: false
}



export const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],

    state: defaultState,

    actions: {
        resetState({commit}) {            
            commit('RESET_STATE')
        }
    },

    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState)
        },
        UPDATE_STATE(state, newState) {
            state.selectedFacility = newState
        },
        GET_SELECTED_FACILITY(state) {
            return state.selectedFacility
        },
        UPDATE_RESPSAFE_STATE(state, newState) {
          state.showRespSafe = newState
        }
    }
})
